import "./ToggleActiveFilters.scss"

import React, {Component} from "react";
import CardCol from "../../../Styled/Card/CardCol.jsx";
import CardRow from "../../../Styled/Card/CardRow.jsx";
import {Input} from "reactstrap";

class ToggleActiveFilters extends Component {
  render() {
    const {
      filterGroups,
      hasFilterActive,
      onCheckboxClick,
    } = this.props

    return (
      <CardRow className="freelance-list-filters">
        {filterGroups.map((filterGroup, index) => {
          return (
            <CardCol
              key={`filter-group-{${index}`}
              className="filter-group-col">
              <CardRow
                direction="column">
                <CardCol className="freelance-list-filters-group-name">
                  {filterGroup.label}
                </CardCol>
                {filterGroup.filters.map((filter) => (
                  <CardCol key={`filter-checkbox-{${filter.filterKey}`}>
                    <label htmlFor={`checkbox-${filter.filterKey}`} onClick={() => onCheckboxClick(filter)}>
                      <Input
                        type="checkbox"
                        name={`checkbox-${filter.filterKey}`}
                        checked={hasFilterActive(filter)}
                        readOnly
                      /> {filter.label}
                    </label>
                  </CardCol>)
                )}
              </CardRow>
            </CardCol>
          )
        })}
      </CardRow>
    )
  }
}

export default ToggleActiveFilters